import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// React.StrictMode ทำให้ code พวก useEffect, useLayoutEffect ฯลฯ ทำงานซ้ำ 2 รอบ
// แต่ React.StrictMode จะเช็คแค่บน dev เท่านั้น ไม่มีผลกับ production
// ref: https://react.dev/reference/react/StrictMode

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
